import { routerHandlers } from "./router";
import { settingsHandlers } from "./settings";
import { teamHandlers } from "./team";
import { techUiHandlers } from "./tech-ui";

// Settings handlers precede the tech-ui ones so the settings `/enums/` variant
// is matched before the tech-ui shell's bare `/enums/` fall-through handler. The
// team handlers sit in the same band: their `*/companies/` and `*/companies/v2/`
// lists must be matched before tech-ui's `*/companies/v2/:companyId` shell lookup.
const handlers = [
  ...routerHandlers,
  ...settingsHandlers,
  ...teamHandlers,
  ...techUiHandlers,
];

export { handlers };
